
import { createAction, props } from '@ngrx/store';

export const loadMemberData = createAction('[Data Member API] Load Data');
export const loadMemberDataSuccess = createAction('[Data Member API] Load Data Success', props<any>());
export const loadMemberDataFailure = createAction('[Data Member API] Load Data Failure', props<any>());
